import React, { useEffect, useState } from 'react'
import useFirstRender from '../../hooks/FirstRender';
import LoadMore from '../../components/common/LoadMore';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { pageModel } from '../../utils/model';
import { useApiProgress } from '../../hooks/ApiProgress';
import { PURCHASE_RETURN_PATH, chargePurchaseReturn, dechargePurchaseReturn, deletePurchaseReturn, getPagePurchaseReturn } from '../../api/purchaseReturnApi'
import { SUPPLIER_PATH, getPageSuppliers } from '../../api/supplierApi';
import Spinner from '../../components/Spinner';
import { RxCross1 } from 'react-icons/rx';
import { setOrderSearchParamsAction, setPurchaseSearchParamsAction } from '../../redux/feature/searchParamsSlice';
import Input from '../../components/Input';
import SupplierPicker from '../../components/supplier/SupplierPicker';
import { formatDate } from '../../utils/functions';
import { AiFillDelete } from 'react-icons/ai';
import DeleteModal from '../../components/DeleteModal';
import CustomerPicker from '../../components/customer/CustomerPicker';
import { CUSTOMER_PATH, getPageCustomers } from '../../api/customerApi';
import { ORDER_RETURN_PATH, chargeOrderReturn, dechargeOrderReturn, deleteOrderReturn, getPageOrderReturn } from '../../api/orderReturnApi';
import { toast } from 'react-toastify';


const ReturnmentHistoryPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const [tab, setTab] = useState('SİPARİŞ') //SATIN ALIM, SİPARİŞ
    const isFirstRender = useFirstRender()
    const nav = useNavigate()
    const dispatch = useDispatch()
    const [purchaseReturnPage, setPurchaseReturnPage] = useState(pageModel)
    const [orderReturnPage, setOrderReturnPage] = useState(pageModel)
    const pendingApiCallPurchase = useApiProgress('get', `${PURCHASE_RETURN_PATH}/page`, false)
    const pendingApiCallOrder = useApiProgress('get', `${ORDER_RETURN_PATH}/page`, false)

    const pendingApiCallSupplier = useApiProgress('get', `${SUPPLIER_PATH}/page`, false)
    const pendingApiCallCustomer = useApiProgress('get', `${CUSTOMER_PATH}/page`, false)
    const purchaseSearchParams = useSelector(state => state.searchParams.purchase)
    const orderSearchParams = useSelector(state => state.searchParams.order)

    const [supplierPage, setSupplierPage] = useState({
        content: []
    });
    const [supplierQuery, setSupplierQuery] = useState('')
    const [searchTimerSupplier, setSearchTimerSupplier] = useState();
    const [searchTimer, setSearchTimer] = useState();

    const [customerPage, setCustomerPage] = useState({
        content: []
    });
    const [customerQuery, setCustomerQuery] = useState('')
    const [searchTimerCustomer, setSearchTimerCustomer] = useState();


    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
    const [isOpenOrderDeleteModal, setIsOpenOrderDeleteModal] = useState(false)
    const [deleteId, setDeleteId] = useState()

    const searchingSupplier = async (params) => {
        if (searchTimerSupplier) clearTimeout(searchTimerSupplier);
        let timer = setTimeout(() => {
            getPageSuppliers(params)
                .then(res => {
                    setSupplierPage(res.data)
                })
        }, 500);
        setSearchTimerSupplier(timer);
    }

    const searchingCustomer = async (params) => {
        if (searchTimerCustomer) clearTimeout(searchTimerCustomer);
        let timer = setTimeout(() => {
            getPageCustomers(params)
                .then(res => {
                    setCustomerPage(res.data)
                })
        }, 500);
        setSearchTimerCustomer(timer);
    }

    const onClickLoadMoreSupplier = () => {
        if (!supplierPage.last) {
            loadSuppliers({ search: supplierQuery, lastId: supplierPage.content[supplierPage.content.length - 1]?.id })
        }
    }

    const onClickLoadMoreCustomer = () => {
        if (!customerPage.last) {
            loadCustomers({ search: customerQuery, lastId: customerPage.content[customerPage.content.length - 1]?.id })
        }
    }

    const loadSuppliers = (params) => {
        !pendingApiCallSupplier &&
            getPageSuppliers(params)
                .then(res => {
                    setSupplierPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const loadCustomers = (params) => {
        !pendingApiCallCustomer &&
            getPageCustomers(params)
                .then(res => {
                    setCustomerPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const loadPurchaseReturns = (params) => {
        !pendingApiCallPurchase &&
            getPagePurchaseReturn(params)
                .then(res => {
                    setPurchaseReturnPage(prevState => ({ ...res.data, content: [...prevState.content, ...res.data.content] }))
                })
    }

    const loadOrderReturns = (params) => {
        !pendingApiCallOrder &&
            getPageOrderReturn(params)
                .then(res => {
                    setOrderReturnPage(prevState => ({ ...res.data, content: [...prevState.content, ...res.data.content] }))
                })
    }

    const onClickChargeReturn = (r) => {
        if (r.charged) {
            dechargePurchaseReturn(r.id)
                .then(res => {
                    setPurchaseReturnPage(prev => ({ ...prev, content: prev.content.map(p => p.id === res.data.id ? res.data : p) }))
                })
        } else {
            chargePurchaseReturn(r.id)
                .then(res => {
                    setPurchaseReturnPage(prev => ({ ...prev, content: prev.content.map(p => p.id === res.data.id ? res.data : p) }))
                })
        }

    }

    const onClickDeleteReturn = (id) => {
        setDeleteId(id)
        setIsOpenDeleteModal(true)
    }

    const onClickDelete = () => {
        deletePurchaseReturn(deleteId)
            .then(res => {
                setPurchaseReturnPage(prev => ({ ...prev, content: prev.content.filter(p => p.id !== deleteId) }))
                setDeleteId()
                setIsOpenDeleteModal(false)
                toast.success('Silindi')
            })
    }

    const onClickDeleteOrder = (id) => {
        setDeleteId(id)
        setIsOpenOrderDeleteModal(true)
    }

    const onClickDeleteOrderReturn = () => {
        deleteOrderReturn(deleteId)
            .then(res => {
                setOrderReturnPage(prev => ({ ...prev, content: prev.content.filter(p => p.id !== deleteId) }))
                setDeleteId()
                setIsOpenOrderDeleteModal(false)
                toast.success('Silindi')
            })
    }


    const searchingPurchaseReturn = async (params) => {
        if (searchTimer) clearTimeout(searchTimer);
        let timer = setTimeout(() => {
            getPagePurchaseReturn(params)
                .then(res => {
                    setPurchaseReturnPage(res.data)
                })
        }, 500);
        setSearchTimer(timer);
    }

    const searchingOrderReturn = async (params) => {
        if (searchTimer) clearTimeout(searchTimer);
        let timer = setTimeout(() => {
            getPageOrderReturn(params)
                .then(res => {
                    setOrderReturnPage(res.data)
                })
        }, 500);
        setSearchTimer(timer);
    }

    const onClickChargeOrderReturn = (r) => {
        if (r.charged) {
            dechargeOrderReturn(r.id)
                .then(res => {
                    setOrderReturnPage(prev => ({ ...prev, content: prev.content.map(p => p.id === res.data.id ? res.data : p) }))
                })
        } else {
            chargeOrderReturn(r.id)
                .then(res => {
                    setOrderReturnPage(prev => ({ ...prev, content: prev.content.map(p => p.id === res.data.id ? res.data : p) }))
                })
        }
    }

    useEffect(() => {
        loadPurchaseReturns({ size: 20, ...purchaseSearchParams, supplierId: purchaseSearchParams.supplier?.id })
        loadOrderReturns({ size: 20, ...orderSearchParams, customerId: orderSearchParams.customer?.id })
        loadSuppliers({ size: 20 })
        loadCustomers({ size: 20 })
    }, [])

    const onLoadMorePurchaseReturns = () => {
        if (!purchaseReturnPage.last) {
            loadPurchaseReturns({ ...purchaseSearchParams, supplierId: purchaseSearchParams.supplier?.id, lastId: purchaseReturnPage.content[purchaseReturnPage.content.length - 1]?.id })
        }
    }

    const onLoadMoreOrderReturns = () => {
        if (!orderReturnPage.last) {
            loadOrderReturns({ ...orderSearchParams, customerId: orderSearchParams.customer?.id, lastId: orderReturnPage.content[orderReturnPage.content.length - 1]?.id })
        }
    }

    useEffect(() => {
        !isFirstRender && searchingPurchaseReturn({ ...purchaseSearchParams, supplierId: purchaseSearchParams.supplier?.id })
    }, [purchaseSearchParams])

    useEffect(() => {
        !isFirstRender && searchingOrderReturn({ ...orderSearchParams, customerId: orderSearchParams.customer?.id })
    }, [orderSearchParams])

    useEffect(() => {
        !isFirstRender && searchingSupplier({ search: supplierQuery })
    }, [supplierQuery])

    useEffect(() => {
        !isFirstRender && searchingCustomer({ search: customerQuery })
    }, [customerQuery])

    return (
        <div>
            <div className='mb-1 border-b border-zinc-300 gap-x-5 flex items-center'>
                <label className='text-2xl'>
                    İADELER
                </label>
            </div>
            <div className='grid grid-cols-2 gap-x-2 py-2 sticky top-0 bg-zinc-50'>
                {['SATIN ALIM', 'SİPARİŞ'].map((t, i) => (
                    <label
                        key={i}
                        className={`${tab === t ? 'bg-purple-700 text-white' : ''} block px-2 py-1 text-xl text-center hover:bg-purple-700 hover:text-white duration-150 cursor-pointer border`}
                        onClick={() => setTab(t)}
                    >
                        {t}
                    </label>
                ))}
            </div>
            {
                tab === 'SATIN ALIM' &&
                <div>
                    <table className='w-full text-left text-zinc-900 mb-10 text-sm'>
                        <thead className='text-xs uppercase tracking-wide sticky top-12 bg-zinc-50'>
                            <tr>
                                <th className='p-2 w-1/12'>Id</th>
                                <th className='p-2 w-3/12'>
                                    <div className='flex justify-between items-center'>
                                        <div className='flex'>
                                            <span>Tedarikçi Adı</span>
                                            <span>{pendingApiCallSupplier && <Spinner />}</span>
                                        </div>
                                        {
                                            purchaseSearchParams.supplier &&
                                            <span onClick={() => dispatch(setPurchaseSearchParamsAction({ key: "supplier", value: null }))}>
                                                <RxCross1 />
                                            </span>
                                        }
                                    </div>
                                </th>
                                <th className='p-2 w-2/12'>Tarih</th>
                                <th className='p-2 w-2/12'>Fatura No</th>
                                <th className='p-2 w-1/12'>Miktar</th>
                                <th className='p-2 w-1/12'>Kullanıcı</th>
                                <th className='p-2 w-1/12'>Hesapta</th>
                                <th className='p-2 w-1/12'>Aksiyon</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className='border-b items-top sticky top-20 bg-zinc-50'>
                                <td className='px-2'>
                                    <Input
                                        name="id"
                                        placeholder='Id...'
                                        onChange={e => dispatch(setPurchaseSearchParamsAction({ key: "id", value: e.target.value }))}
                                    />
                                </td>
                                <td className='px-2'>
                                    {/* SUPPLIER SEARCH */}
                                    <SupplierPicker
                                        //pendingApiCall={pendingApiCallSupplier}
                                        state={purchaseSearchParams.supplier}
                                        setState={(value) => dispatch(setPurchaseSearchParamsAction({ key: 'supplier', value }))}
                                        query={supplierQuery}
                                        setQuery={setSupplierQuery}
                                        page={supplierPage}
                                        //onClickClear={() => dispatch(setPurchaseSearchParamsAction({ key: 'supplier', value: null }))}
                                        onClickLoadMore={() => onClickLoadMoreSupplier()}
                                    />
                                </td>
                                <td className='px-2 gap-x-1'></td>
                                <td className='px-2 gap-x-1'>
                                    <Input
                                        name='invoiceNumber'
                                        placeholder='Fatura no girin..'
                                        value={purchaseSearchParams.invoiceNumber}
                                        onChange={e => dispatch(setPurchaseSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                                    />
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            {
                                purchaseReturnPage.content.map((r, i) => (
                                    <tr key={i}>
                                        <td className='p-2'># {r.id} </td>
                                        <td className='p-2'>{r.supplierName} </td>
                                        <td className='p-2'>{formatDate(r.returnmentDate)} </td>
                                        <td className='p-2'>{r.invoiceNumber} </td>
                                        <td className='p-2'>{r.quantity} m</td>
                                        <td className='p-2'>{r.username} </td>
                                        <td className='p-2 text-center'>
                                            <input
                                                type='checkbox'
                                                checked={r.charged}
                                                defaultChecked={r.charged}
                                                onChange={() => onClickChargeReturn(r)}
                                            />
                                        </td>
                                        <td>
                                            {
                                                !r.charged &&
                                                <span
                                                    className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                                    onClick={() => onClickDeleteReturn(r.id)}
                                                >
                                                    <AiFillDelete />
                                                </span>
                                            }

                                        </td>
                                        <td className='px-2 gap-x-1'>

                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                    <LoadMore page={purchaseReturnPage} pending={pendingApiCallPurchase} onLoadMore={onLoadMorePurchaseReturns} />
                </div>
            }
            {
                tab === 'SİPARİŞ' &&
                <div>
                    <table className='w-full text-left text-zinc-900 mb-10 text-sm'>
                        <thead className='text-xs uppercase tracking-wide sticky top-12 bg-zinc-50'>
                            <tr>
                                <th className='p-2 w-1/12'>Id</th>
                                <th className='p-2 w-3/12'>
                                    <div className='flex justify-between items-center'>
                                        <div className='flex'>
                                            <span>Müşteri Adı</span>
                                            <span>{pendingApiCallCustomer && <Spinner />}</span>
                                        </div>
                                        {
                                            orderSearchParams.customer &&
                                            <span onClick={() => dispatch(setOrderSearchParamsAction({ key: "customer", value: null }))}>
                                                <RxCross1 />
                                            </span>
                                        }
                                    </div>
                                </th>
                                <th className='p-2 w-2/12'>Tarih</th>
                                <th className='p-2 w-2/12'>Fatura No</th>
                                <th className='p-2 w-1/12'>Miktar</th>
                                <th className='p-2 w-1/12'>Kullanıcı</th>
                                <th className='p-2 w-1/12'>Hesapta</th>
                                <th className='p-2 w-1/12'>Aksiyon</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className='border-b items-top sticky top-20 bg-zinc-50'>
                                <td className='px-2'>
                                    <Input
                                        name="id"
                                        placeholder='Id...'
                                        onChange={e => dispatch(setOrderSearchParamsAction({ key: "id", value: e.target.value }))}
                                    />
                                </td>
                                <td className='px-2'>
                                    <CustomerPicker
                                        state={orderSearchParams.customer}
                                        setState={(value) => dispatch(setOrderSearchParamsAction({ key: 'customer', value }))}
                                        query={customerQuery}
                                        setQuery={setCustomerQuery}
                                        page={customerPage}
                                        onClickLoadMore={() => onClickLoadMoreCustomer()}
                                    />
                                </td>
                                <td className='px-2 gap-x-1'></td>
                                <td className='px-2 gap-x-1'>
                                    <Input
                                        name='invoiceNumber'
                                        placeholder='Fatura no girin..'
                                        value={orderSearchParams.invoiceNumber}
                                        onChange={e => dispatch(setOrderSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                                    />
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            {
                                orderReturnPage.content.map((r, i) => (
                                    <tr key={i}>
                                        <td className='p-2'># {r.id} </td>
                                        <td className='p-2'>{r.customer.name} </td>
                                        <td className='p-2'>{formatDate(r.returnmentDate)} </td>
                                        <td className='p-2'>{r.order.invoiceNumber} </td>
                                        <td className='p-2'>{r.quantity} m</td>
                                        <td className='p-2'>{r.username} </td>
                                        <td className='p-2 text-center'>
                                            <input
                                                type='checkbox'
                                                checked={r.charged}
                                                defaultChecked={r.charged}
                                                onChange={() => onClickChargeOrderReturn(r)}
                                            />
                                        </td>
                                        <td>
                                            {
                                                !r.charged &&
                                                <span
                                                    className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                                    onClick={() => onClickDeleteOrder(r.id)}
                                                >
                                                    <AiFillDelete />
                                                </span>
                                            }

                                        </td>
                                        <td className='px-2 gap-x-1'>

                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                    <LoadMore page={orderReturnPage} pending={pendingApiCallOrder} onLoadMore={onLoadMoreOrderReturns} />
                </div>
            }

            <DeleteModal
                isOpen={isOpenDeleteModal}
                closeModal={() => setIsOpenDeleteModal(false)}
                onClick={onClickDelete}
            />
            <DeleteModal
                isOpen={isOpenOrderDeleteModal}
                closeModal={() => setIsOpenOrderDeleteModal(false)}
                onClick={onClickDeleteOrderReturn}
            />
        </div>
    )
}

export default ReturnmentHistoryPage